
import { Create, Edit } from 'react-admin';
import list from './list';
import { FormFields } from './components';

export const create = () => (
	<Create>
		{FormFields}
	</Create>
);

export const edit = () => (
	<Edit>
		{FormFields}
	</Edit>
);

export const Voice = {
	list,
	edit,
	create
}

export default Voice;